var extend = require('./extend');

var jsonpExtraStamp = 0;

var load = module.exports = {
    script: function script(url, callback) {
        var head = document.getElementsByTagName('head')[0],
            script = document.createElement('script'),
            remove = function remove() {
            if (timer) {
                clearTimeout(timer);
            }
            head.removeChild(script);
        },
            timer = setTimeout(script.onerror = function () {
            remove();
            callback && callback(true);
        }, 30000);
        script.setAttribute('src', url);
        head.appendChild(script);
        script.onload = function () {
            remove();
            callback && callback();
        };
    }
};


//////////////////
// WEBPACK FOOTER
// ../src/util/load.js
// module id = 9
// module chunks = 0 2 4